import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useInfiniteShorts } from '../../hooks/useGetShorts';
import NewShortsPlayer from './NewShortsPlayer';

const ShortsPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { shorts, isLoading } = useInfiniteShorts(50);
  
  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  // Show loading while shorts are being fetched
  if (isLoading || !shorts || shorts.length === 0) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        zIndex: 10000
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255, 255, 255, 0.3)',
          borderTop: '3px solid #fff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    );
  }

  return (
    <NewShortsPlayer
      initialShortSlug={slug} 
      shorts={shorts} 
      onClose={handleClose}
    />
  );
};

export default ShortsPage;